const sv = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Laddar...',
    error: 'Fel',
    save: 'Spara',
    cancel: 'Avbryt',
    delete: 'Radera',
    edit: 'Redigera',
    create: 'Skapa',
    add: 'Lägg till',
    remove: 'Ta bort',
    close: 'Stäng',
    confirm: 'Bekräfta',
    apply: 'Tillämpa',
    reset: 'Återställ',
    search: 'Sök',
    filter: 'Filtrera',
    clear: 'Rensa',
    back: 'Tillbaka',
    next: 'Nästa',
    previous: 'Föregående',
    submit: 'Skicka',
    update: 'Uppdatera',
    refresh: 'Uppdatera',
    export: 'Exportera',
    import: 'Importera',
    download: 'Ladda ner',
    upload: 'Ladda upp',
    print: 'Skriv ut',
    copy: 'Kopiera',
    yes: 'Ja',
    no: 'Nej',
    ok: 'OK',
    done: 'Klart',
    select: 'Välj',
    selectAll: 'Välj alla',
    deselectAll: 'Avmarkera alla',
    noResults: 'Inga resultat hittades',
    noData: 'Inga data tillgängliga',
    required: 'Obligatoriskt',
    optional: 'Valfritt',
    actions: 'Åtgärder',
    details: 'Detaljer',
    overview: 'Översikt',
    summary: 'Sammanfattning',
    total: 'Totalt',
    all: 'Alla',
    none: 'Ingen',
    name: 'Namn',
    type: 'Typ',
    status: 'Status',
    date: 'Datum',
    time: 'Tid',
    description: 'Beskrivning',
    notes: 'Anteckningar',
    comments: 'Kommentarer',
    category: 'Kategori',
    priority: 'Prioritet',
    nation: 'Nation',
    country: 'Land',
    email: 'E-post',
    phone: 'Telefon',
    address: 'Adress',
    location: 'Plats',
    coordinates: 'Koordinater',
    latitude: 'Latitud',
    longitude: 'Longitud',
    from: 'Från',
    to: 'Till',
    createdAt: 'Skapad',
    updatedAt: 'Uppdaterad',
    createdBy: 'Skapad av',
    modifiedBy: 'Ändrad av',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    enabled: 'Aktiverad',
    disabled: 'Inaktiverad',
    showing: 'Visar',
    of: 'av',
    page: 'Sida',
    perPage: 'per sida',
    rows: 'rader',
    items: 'objekt',
    results: 'resultat',
    sortBy: 'Sortera efter',
    ascending: 'Stigande',
    descending: 'Fallande',
    viewAll: 'Visa alla',
    viewDetails: 'Visa detaljer',
    goBack: 'Gå tillbaka',
    learnMore: 'Läs mer',
    seeMore: 'Se mer',
    showMore: 'Visa mer',
    showLess: 'Visa mindre',
    expandAll: 'Expandera alla',
    collapseAll: 'Minimera alla',
    copied: 'Kopierat!',
    saved: 'Sparat!',
    deleted: 'Raderat!',
    updated: 'Uppdaterat!',
    created: 'Skapat!',
    success: 'Lyckades',
    warning: 'Varning',
    info: 'Information',
    danger: 'Fara',
    unknown: 'Okänd',
    notAvailable: 'Ej tillgänglig',
    never: 'Aldrig',
    today: 'Idag',
    yesterday: 'Igår',
    tomorrow: 'Imorgon',
    now: 'Nu',
    ago: 'sedan',
    justNow: 'just nu',
    minutesAgo: '{{count}} min sedan',
    hoursAgo: '{{count}} tim sedan',
    daysAgo: '{{count}} d sedan',
    monthsAgo: '{{count}} mån sedan',
    id: 'ID',
    version: 'Version',
    language: 'Språk',
    theme: 'Tema',
    darkMode: 'Mörkt läge',
    lightMode: 'Ljust läge',
    failedToLoad: 'Kunde inte ladda data',
    failedToSave: 'Kunde inte spara',
    failedToDelete: 'Kunde inte radera',
    failedToUpdate: 'Kunde inte uppdatera',
    confirmDelete: 'Är du säker på att du vill radera detta?',
    confirmAction: 'Är du säker?',
    unsavedChanges: 'Du har osparade ändringar. Är du säker på att du vill lämna?',
    pageNotFound: '404 – Sidan hittades inte',
    pageNotFoundDesc: 'Sidan du söker finns inte.',
    backToDashboard: 'Tillbaka till instrumentpanelen',
    characters: 'tecken',
    maxCharacters: 'Maximalt {{max}} tecken',
    remaining: '{{count}} kvar',
    selected: '{{count}} valda',
    of_total: '{{count}} av {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Instrumentpanel',
    requests: 'Förfrågningar',
    transports: 'Transporter',
    myPatients: 'Mina patienter',
    statistics: 'Statistik',
    flow: 'Flöde',
    resources: 'Resources',
    exercise: 'Övning',
    administration: 'Administration',
    map: 'Karta',
    info: 'Information',
    users: 'Användare',
    assets: 'Resurser',
    hubs: 'Knutpunkter',
    treatmentFacilities: 'Vårdinrättningar',
    patientImport: 'Patientimport',
    assetTemplates: 'Resursmallar',
    dayTemplates: 'Dagsmallar',
    announcementTicker: 'Meddelandefält',
    exerciseStatistics: 'Övningsstatistik',
    settings: 'Inställningar',
    auditLog: 'Granskningslogg',
    exerciseControl: 'Övningskontroll',
    dataSync: 'Datasynkronisering',
    documentation: 'Dokumentation',
    support: 'Support',
    about: 'Om',
    assetContracts: 'Asset Contracts',
    notifications: 'Aviseringar',
    schedules: 'Tidtabeller',
    capacityPlanning: 'Kapacitetsplanering',
    transportPlanning: 'Transportplanering',
    transportBooking: 'Transportbokning',
    flowDiagram: 'Flödesdiagram',
    changePassword: 'Byt lösenord',
    missions: 'Uppdrag',
    startPoints: 'Startpunkter',
    hospital: 'Sjukhus',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Logga in',
    logout: 'Logga ut',
    logoutNow: 'Logga ut nu',
    loggingIn: 'Loggar in...',
    loginFailed: 'Inloggningen misslyckades',
    email: 'E-post',
    password: 'Lösenord',
    username: 'Användarnamn',
    enterEmail: 'Ange din e-postadress',
    enterPassword: 'Ange ditt lösenord',
    enterUsername: 'Ange ditt användarnamn',
    forgotPassword: 'Glömt lösenord?',
    forgotPasswordTitle: 'Glömt lösenord',
    forgotPasswordDesc: 'Ange ditt användarnamn och din e-postadress. Om båda stämmer meddelas administratörerna om lösenordsåterställning.',
    requestPasswordReset: 'Begär lösenordsåterställning',
    sending: 'Skickar...',
    backToLogin: 'Tillbaka till inloggning',
    pleaseWait: 'Vänta innan du försöker igen.',
    requestFailed: 'Begäran misslyckades',
    credentialsMatch: 'Om uppgifterna stämmer har administratörerna meddelats.',
    forAccess: 'Kontakta systemadministratören för att få åtkomst.',
    changePassword: 'Byt lösenord',
    currentPassword: 'Nuvarande lösenord',
    newPassword: 'Nytt lösenord',
    confirmPassword: 'Bekräfta lösenord',
    passwordChanged: 'Lösenordet har ändrats',
    passwordMismatch: 'Lösenorden matchar inte',
    passwordTooShort: 'Lösenordet måste vara minst 8 tecken',
    changingPassword: 'Ändrar...',
    mustChangePassword: 'Du måste byta lösenord innan du kan fortsätta.',
    sessionExpiring: 'Sessionen löper ut',
    sessionExpireText: 'Din session löper ut om <strong>{{time}}</strong>. Spara ditt arbete och logga in igen för att fortsätta.',
    dismiss: 'Avfärda',
    switchNation: 'Byt nation',
    returnTo: 'Återgå till {{nation}}',
    viewingAs: 'Du visar som',
    loggedInAs: 'inloggad som {{nation}}',
    trainingMode: 'ENBART FÖR ÖVNINGSÄNDAMÅL',
    dedication: 'Skapat med kärlek och hängivenhet till yrket',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Systemadministratör',
    excon: 'Övningsledare',
    eu: 'EU-koordinator',
    planner: 'Planerare',
    hub: 'Knutpunktschef',
    nation: 'Nation',
    readOnly: 'Skrivskyddad',
    systemAdmin: 'Systemadministratör',
    transportPlanner: 'Transportplanerare',
    systemRoles: 'Systemroller',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Utkast',
    underReview: 'Under granskning',
    published: 'Publicerad',
    underSelection: 'Under urval',
    accepted: 'Accepterad',
    planned: 'Planerad',
    inTransit: 'Under transport',
    completed: 'Slutförd',
    closed: 'Stängd',
    withdrawn: 'Återkallad',
    pending: 'Väntande',
    rejected: 'Avvisad',
    cancelled: 'Annullerad',
    active: 'Aktiv',
    inactive: 'Inaktiv',
    review: 'Granskning',
    selection: 'Urval',
    transit: 'Transport',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personal',
    material: 'Material',
    equipment: 'Utrustning',
    other: 'Övrigt',
    news: 'Nyheter',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Rutin',
    priority: 'Prioritet',
    urgent: 'Brådskande',
    immediate: 'Omedelbar',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Tåg',
    ship: 'Fartyg',
    aircraft: 'Flygplan',
    bus: 'Buss',
    ambulance: 'Ambulans',
    drone: 'Drönare',
    helicopter: 'Helikopter',
    ferry: 'Färja',
    other: 'Övrigt',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Instrumentpanel',
    goodMorning: 'God morgon',
    goodAfternoon: 'God eftermiddag',
    goodEvening: 'God kväll',
    lastLogin: 'Senaste inloggning',
    infrastructure: 'Infrastruktur',
    transportAssets: 'Transportresurser',
    treatmentFacilities: 'Vårdinrättningar',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Förfrågningsstatistik',
    viewAllRequests: 'Visa alla förfrågningar',
    availableAssets: 'Tillgängliga resurser',
    seated: 'Sittande',
    lying: 'Liggande',
    intensive: 'Intensivvård',
    notifications: 'Aviseringar',
    markAllRead: 'Markera alla som lästa',
    noNotifications: 'Inga aviseringar ännu',
    notifiedWhenActivity: 'Du meddelas när ny aktivitet uppstår',
    viewDetailsBtn: 'Visa detaljer',
    nationUsers: 'Nationens användare',
    user: 'Användare',
    roles: 'Roller',
    noUsersFound: 'Inga användare hittades',
    participatingNations: 'Deltagande nationer',
    exerciseDisclaimer: 'Detta system är avsett enbart för övningsbruk. Ange uteslutande simulerad övningsdata. Arbetsflödena är anpassade till övningsscenariot och kan skilja sig från verkliga rutiner. IT-säkerhets- och dataskyddsregler gäller fullt ut.',
    notConfigured: 'Ej konfigurerad',
    requestCount: '{{count}} förfrågan(-ar)',
    clickToView: 'Klicka för att visa',
    systemAdministration: 'Systemadministration',
    exerciseControlTitle: 'Övningskontroll',
    euCoordination: 'EU-koordinering',
    transportPlanningTitle: 'Transportplanering',
    hubManagement: 'Knutpunktshantering',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Ny förfrågan',
    myDrafts: 'Mina utkast',
    pendingReview: 'Väntar på granskning',
    activeTransports: 'Aktiva transporter',
    myPatients: 'Mina patienter',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Förfrågningar',
    newRequest: 'Ny förfrågan',
    createRequest: 'Skapa förfrågan',
    editRequest: 'Redigera förfrågan',
    requestDetail: 'Förfrågningsdetaljer',
    requestId: 'Förfrågnings-ID',
    fromNation: 'Från nation',
    toNation: 'Till nation',
    requestingNation: 'Begärande nation',
    receivingNation: 'Mottagande nation',
    category: 'Kategori',
    urgency: 'Brådskande',
    status: 'Status',
    patients: 'Patienter',
    patientCount: 'Antal patienter',
    offers: 'Erbjudanden',
    offerCount: 'Antal erbjudanden',
    created: 'Skapad',
    updated: 'Uppdaterad',
    submittedBy: 'Inskickad av',
    reviewedBy: 'Granskad av',
    description: 'Beskrivning',
    medicalDetails: 'Medicinska detaljer',
    transportDetails: 'Transportdetaljer',
    additionalInfo: 'Ytterligare information',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Avgångspunkt',
    arrivalPoint: 'Ankomstpunkt',
    estimatedDeparture: 'Beräknad avgång',
    estimatedArrival: 'Beräknad ankomst',
    submitForReview: 'Skicka för granskning',
    publish: 'Publicera',
    startSelection: 'Starta urval',
    acceptOffer: 'Acceptera erbjudande',
    markInTransit: 'Markera som under transport',
    markCompleted: 'Markera som slutförd',
    closeRequest: 'Stäng förfrågan',
    withdrawRequest: 'Återkalla förfrågan',
    withdraw: 'Återkalla',
    revertToDraft: 'Återställ till utkast',
    deleteRequest: 'Radera förfrågan',
    duplicateRequest: 'Duplicera förfrågan',
    createFollowUp: 'Skapa konsoliderad förfrågan',
    followUpRequest: 'Konsoliderad förfrågan',
    parentRequest: 'Ursprunglig förfrågan',
    childRequests: 'Konsoliderade förfrågningar',
    noRequests: 'Inga förfrågningar hittades',
    noOffers: 'Inga erbjudanden ännu',
    addPatient: 'Lägg till patient',
    removePatient: 'Ta bort patient',
    patientDetails: 'Patientuppgifter',
    contactPerson: 'Kontaktperson',
    contactPhone: 'Kontakttelefon',
    contactEmail: 'Kontakt-e-post',
    specialRequirements: 'Särskilda krav',
    medicalEquipment: 'Medicinsk utrustning',
    accompaniment: 'Medföljande',
    timeline: 'Tidslinje',
    history: 'Historik',
    addComment: 'Lägg till kommentar',
    writeComment: 'Skriv en kommentar...',
    postComment: 'Publicera kommentar',
    posting: 'Publicerar...',
    noComments: 'Inga kommentarer ännu',
    coverageBar: 'Täckning',
    covered: 'täckt',
    uncovered: 'otäckt',
    filterByStatus: 'Filtrera efter status',
    filterByCategory: 'Filtrera efter kategori',
    filterByNation: 'Filtrera efter nation',
    searchRequests: 'Sök förfrågningar...',
    confirmWithdraw: 'Är du säker på att du vill återkalla denna förfrågan?',
    confirmDelete: 'Är du säker på att du vill radera denna förfrågan?',
    confirmPublish: 'Är du säker på att du vill publicera denna förfrågan? Den blir synlig för alla nationer.',
    confirmStartSelection: 'Är du säker på att du vill starta urvalet? Nationer kan lämna erbjudanden.',
    warningStartSelection: 'Att starta urvalet gör denna förfrågan synlig för alla deltagande nationer. De kan skicka in erbjudanden för patienterna i denna förfrågan. Denna åtgärd kan inte ångras.',
    warningMakeOffer: 'Genom att skicka detta erbjudande förbinder du din nation att tillhandahålla den föreslagna hjälpen. Denna åtgärd meddelar den begärande nationen och övningsledningen.',
    saveDraft: 'Spara utkast',
    saving: 'Sparar...',
    saveAndSubmit: 'Spara och skicka',
    step: 'Steg {{number}}',
    generalInfo: 'Allmän information',
    patientInfo: 'Patientinformation',
    logisticsInfo: 'Logistikinformation',
    reviewSubmit: 'Granska och skicka',
    requestTitle: 'Förfrågans titel',
    requestDescription: 'Förfrågans beskrivning',
    numberOfPatients: 'Antal patienter',
    typeOfAssistance: 'Typ av hjälp',
    medicalTreatment: 'Medicinsk behandling',
    transportAssistance: 'Transporthjälp',
    both: 'Båda',
    treatmentOnly: 'Enbart behandling',
    transportOnly: 'Enbart transport',
    validationErrors: 'Rätta följande fel:',
    fieldRequired: 'Detta fält är obligatoriskt',
    selectExitHub: 'Välj utgångsknutpunkt',
    createExitHub: 'Skapa utgångsknutpunkt',
    backToRequests: 'Tillbaka till förfrågningar',
    noRequestsFound: 'Inga förfrågningar hittades',
    createFirstRequest: 'Skapa din första förfrågan för att komma igång',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Erbjudanden',
    createOffer: 'Skapa erbjudande',
    makeOffer: 'Lämna erbjudande',
    manageOffers: 'Hantera erbjudanden',
    offerDetail: 'Erbjudandedetaljer',
    offerId: 'Erbjudande-ID',
    offeringNation: 'Erbjudande nation',
    offerType: 'Erbjudandetyp',
    treatment: 'Behandling',
    transport: 'Transport',
    combined: 'Kombinerat',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Behandlingserbjudande',
    transportOffer: 'Transporterbjudande',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Välj patienter',
    selectedPatients: 'Valda patienter',
    patientSelection: 'Patienturval',
    offerConfiguration: 'Erbjudandekonfiguration',
    reviewOffer: 'Granska erbjudande',
    submitOffer: 'Skicka erbjudande',
    submitting: 'Skickar...',
    acceptOffer: 'Acceptera erbjudande',
    rejectOffer: 'Avvisa erbjudande',
    withdrawOffer: 'Återkalla erbjudande',
    noOffers: 'Inga erbjudanden tillgängliga',
    noOffer: 'No Offer',
    offerStatus: 'Erbjudandestatus',
    offerDate: 'Erbjudandedatum',
    transportAsset: 'Transportresurs',
    departureDate: 'Avgångsdatum',
    arrivalDate: 'Ankomstdatum',
    treatmentFacility: 'Vårdinrättning',
    capacity: 'Kapacitet',
    availableCapacity: 'Tillgänglig kapacitet',
    totalCapacity: 'Total kapacitet',
    selectAsset: 'Välj resurs',
    selectFacility: 'Välj inrättning',
    offerNotes: 'Erbjudandeanteckningar',
    confirmAccept: 'Är du säker på att du vill acceptera detta erbjudande?',
    confirmReject: 'Är du säker på att du vill avvisa detta erbjudande?',
    extendTransport: 'Förläng transport',
    transportExtension: 'Transportförlängning',
    comparisonView: 'Jämförelsevy',
    shortlist: 'Urvalslista',
    addToShortlist: 'Lägg till i urvalslistan',
    removeFromShortlist: 'Ta bort från urvalslistan',
    leaveConfirmTitle: 'Lämna denna sida?',
    leaveConfirmMessage: 'Du har osparade ändringar. Är du säker på att du vill lämna?',
    stayOnPage: 'Stanna på sidan',
    leavePage: 'Lämna sidan',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporter',
    missionDetail: 'Transportdetaljer',
    missionId: 'Transport-ID',
    missionStatus: 'Transportstatus',
    createMission: 'Skapa transport',
    overview: 'Översikt',
    patientsTab: 'Patienter',
    transportsTab: 'Transportetapper',
    treatmentTab: 'Behandling',
    reviewTab: 'Granskning',
    departure: 'Avgång',
    arrival: 'Ankomst',
    origin: 'Ursprung',
    destination: 'Destination',
    stops: 'Stopp',
    addStop: 'Lägg till stopp',
    removeStop: 'Ta bort stopp',
    stopName: 'Stoppnamn',
    stopType: 'Stopptyp',
    estimatedTime: 'Beräknad tid',
    actualTime: 'Faktisk tid',
    asset: 'Resurs',
    driver: 'Förare',
    crew: 'Besättning',
    noMissions: 'Inga transporter hittades',
    completeMission: 'Slutför transport',
    cancelMission: 'Avbryt transport',
    startTransport: 'Starta transport',
    missionChain: 'Transportkedja',
    linkedMissions: 'Länkade transporter',
    handover: 'Överlämning',
    handoverPoint: 'Överlämningspunkt',
    pickupPoint: 'Upphämtningspunkt',
    dropoffPoint: 'Avlämningspunkt',
    searchTransports: 'Sök transporter...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Patienter',
    myPatients: 'Mina patienter',
    patientId: 'Patient-ID',
    firstName: 'Förnamn',
    lastName: 'Efternamn',
    dateOfBirth: 'Födelsedatum',
    age: 'Ålder',
    gender: 'Kön',
    male: 'Man',
    female: 'Kvinna',
    other: 'Annat',
    nationality: 'Nationalitet',
    diagnosis: 'Diagnos',
    condition: 'Tillstånd',
    stable: 'Stabilt',
    critical: 'Kritiskt',
    serious: 'Allvarligt',
    treatmentNeeded: 'Behandling krävs',
    allergies: 'Allergier',
    medications: 'Mediciner',
    bloodType: 'Blodgrupp',
    weight: 'Vikt (kg)',
    infectious: 'Smittsam',
    mentalHealth: 'Psykisk hälsa',
    mobility: 'Mobilitet',
    ambulatory: 'Gående',
    wheelchair: 'Rullstol',
    stretcher: 'Bår',
    intensive: 'Intensivvård',
    oxygenRequired: 'Syrgas krävs',
    ventilator: 'Ventilator',
    medicalEscort: 'Medicinsk eskort',
    noPatients: 'Inga patienter hittades',
    patientDetails: 'Patientuppgifter',
    medicalHistory: 'Sjukdomshistorik',
    travelDocuments: 'Resedokument',
    passport: 'Pass',
    pseudonymizedId: 'Pseudonymiserat ID',
    sensitiveData: 'Känslig data',
    journey: 'Patientens resa',
    assignedTo: 'Tilldelad till',
    currentLocation: 'Nuvarande plats',
    importPatients: 'Importera patienter',
    exportPatients: 'Exportera patienter',
    seated: 'Sittande',
    lying: 'Liggande',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Användare',
    createUser: 'Skapa användare',
    editUser: 'Redigera användare',
    deleteUser: 'Radera användare',
    username: 'Användarnamn',
    displayName: 'Visningsnamn',
    email: 'E-post',
    password: 'Lösenord',
    role: 'Roll',
    roles: 'Roller',
    nation: 'Nation',
    active: 'Aktiv',
    lastLogin: 'Senaste inloggning',
    createdAt: 'Skapad',
    isNation: 'Nation',
    isEU: 'EU',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Planerare',
    isHub: 'Knutpunkt',
    isReadOnly: 'Skrivskyddad',
    noUsers: 'Inga användare hittades',
    confirmDelete: 'Är du säker på att du vill radera denna användare?',
    resetPassword: 'Återställ lösenord',
    generatePassword: 'Generera lösenord',
    searchUsers: 'Sök användare...',
    userCreated: 'Användaren har skapats',
    userUpdated: 'Användaren har uppdaterats',
    userDeleted: 'Användaren har raderats',
    selectNation: 'Välj en nation',
    mustChangePassword: 'Måste byta lösenord vid nästa inloggning',
    flagImage: 'Flaggbild',
    exportUsers: 'Exportera användare',
    importUsers: 'Importera användare',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Resurser',
    createAsset: 'Skapa resurs',
    editAsset: 'Redigera resurs',
    deleteAsset: 'Radera resurs',
    assetName: 'Resursnamn',
    assetType: 'Resurstyp',
    capacitySeated: 'Kapacitet (sittande)',
    capacityLying: 'Kapacitet (liggande)',
    capacityIntensive: 'Kapacitet (intensivvård)',
    owner: 'Ägare',
    operator: 'Operatör',
    baseLocation: 'Basplats',
    range: 'Räckvidd',
    speed: 'Hastighet',
    noAssets: 'Inga resurser hittades',
    confirmDelete: 'Är du säker på att du vill radera denna resurs?',
    searchAssets: 'Sök resurser...',
    assetCreated: 'Resursen har skapats',
    assetUpdated: 'Resursen har uppdaterats',
    assetDeleted: 'Resursen har raderats',
    exportAssets: 'Exportera resurser',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Knutpunkter',
    startPoints: 'Startpunkter',
    createHub: 'Skapa knutpunkt',
    editHub: 'Redigera knutpunkt',
    deleteHub: 'Radera knutpunkt',
    hubName: 'Knutpunktsnamn',
    hubType: 'Knutpunktstyp',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Ingångsknutpunkt',
    airport: 'Flygplats',
    seaport: 'Hamn',
    railStation: 'Järnvägsstation',
    roadPoint: 'Vägpunkt',
    ucpmClassification: 'UCPM-klassificering',
    icaoCode: 'ICAO-kod',
    iataCode: 'IATA-kod',
    noHubs: 'Inga knutpunkter hittades',
    confirmDelete: 'Är du säker på att du vill radera denna knutpunkt?',
    searchHubs: 'Sök knutpunkter...',
    nationAssignment: 'Nationstilldelning',
    assignNations: 'Tilldela nationer',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Vårdinrättningar',
    createFacility: 'Skapa inrättning',
    editFacility: 'Redigera inrättning',
    deleteFacility: 'Radera inrättning',
    facilityName: 'Inrättningsnamn',
    facilityType: 'Inrättningstyp',
    hospitalName: 'Sjukhusnamn',
    bedCapacity: 'Sängkapacitet',
    specialties: 'Specialiteter',
    availableBeds: 'Tillgängliga sängar',
    totalBeds: 'Totalt antal sängar',
    contactPerson: 'Kontaktperson',
    noFacilities: 'Inga vårdinrättningar hittades',
    confirmDelete: 'Är du säker på att du vill radera denna inrättning?',
    searchFacilities: 'Sök inrättningar...',
    hubNationAssignment: 'Knutpunktens nationstilldelning',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Tidtabeller',
    createSchedule: 'Skapa tidtabell',
    editSchedule: 'Redigera tidtabell',
    deleteSchedule: 'Radera tidtabell',
    scheduleName: 'Tidtabellsnamn',
    scheduleType: 'Tidtabellstyp',
    recurring: 'Återkommande',
    oneTime: 'Engångs',
    frequency: 'Frekvens',
    daily: 'Dagligen',
    weekly: 'Veckovis',
    startDate: 'Startdatum',
    endDate: 'Slutdatum',
    departureTime: 'Avgångstid',
    arrivalTime: 'Ankomsttid',
    stops: 'Stopp',
    addStop: 'Lägg till stopp',
    noSchedules: 'Inga tidtabeller hittades',
    bookings: 'Bokningar',
    timeline: 'Tidslinje',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Aviseringar',
    markAllRead: 'Markera alla som lästa',
    markAsRead: 'Markera som läst',
    markAsUnread: 'Markera som oläst',
    noNotifications: 'Inga aviseringar',
    viewAll: 'Visa alla aviseringar',
    settings: 'Aviseringsinställningar',
    emailNotifications: 'E-postaviseringar',
    inAppNotifications: 'Aviseringar i appen',
    notifyOn: 'Meddela mig om',
    requestCreated: 'Ny förfrågan',
    requestPublished: 'Förfrågan publicerad',
    requestClosed: 'Förfrågan stängd',
    requestCompleted: 'Förfrågan slutförd',
    commentAdded: 'Ny kommentar',
    offerReceived: 'Erbjudande mottaget',
    offerAccepted: 'Erbjudande accepterat',
    statusChanged: 'Status ändrad',
    selectionStarted: 'Urval startat',
    missionCreated: 'Transport skapad',
    missionStatusUpdated: 'Transport uppdaterad',
    transportPartnerNamed: 'Transportpartner',
    transportExtensionReceived: 'Transportförlängning',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Inställningar',
    general: 'Allmänt',
    system: 'System',
    email: 'E-post',
    sync: 'Synkronisering',
    security: 'Säkerhet',
    appearance: 'Utseende',
    systemName: 'Systemnamn',
    systemEmail: 'System-e-post',
    maintenanceMode: 'Underhållsläge',
    readOnlyMode: 'Skrivskyddat läge',
    emailEnabled: 'E-post aktiverad',
    smtpHost: 'SMTP-värd',
    smtpPort: 'SMTP-port',
    smtpUser: 'SMTP-användare',
    smtpPassword: 'SMTP-lösenord',
    senderEmail: 'Avsändar-e-post',
    senderName: 'Avsändarnamn',
    testEmail: 'Skicka test-e-post',
    syncEnabled: 'Synkronisering aktiverad',
    syncUrl: 'Synkroniserings-URL',
    syncApiKey: 'Synkroniserings-API-nyckel',
    settingsSaved: 'Inställningarna har sparats',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Helpdesktitel',
    helpdeskEmail: 'Helpdesk-e-post',
    helpdeskPhone: 'Helpdesktelefon',
    helpdeskInfo: 'Helpdeskinformation',
    realLifeSupport: 'Stöd i verkliga situationer',
    trainingMode: 'Övningsläge',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Granskningslogg',
    action: 'Åtgärd',
    user: 'Användare',
    target: 'Mål',
    details: 'Detaljer',
    timestamp: 'Tidsstämpel',
    ipAddress: 'IP-adress',
    noLogs: 'Inga granskningsloggar hittades',
    searchLogs: 'Sök loggar...',
    filterByAction: 'Filtrera efter åtgärd',
    filterByUser: 'Filtrera efter användare',
    exportLogs: 'Exportera loggar',
    exportCsv: 'Exportera CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Övningskontroll',
    currentDay: 'Aktuell dag',
    exerciseDay: 'Övningsdag',
    nextDay: 'Nästa dag',
    previousDay: 'Föregående dag',
    resetExercise: 'Återställ övning',
    startExercise: 'Starta övning',
    endExercise: 'Avsluta övning',
    dayReset: 'Dagsåterställning',
    confirmReset: 'Är du säker på att du vill återställa övningsdagen? All data för den aktuella dagen raderas.',
    resetInProgress: 'Återställning pågår...',
    maintenanceMode: 'Underhållsläge',
    enableMaintenance: 'Aktivera underhåll',
    disableMaintenance: 'Inaktivera underhåll',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Datasynkronisering',
    syncStatus: 'Synkroniseringsstatus',
    lastSync: 'Senaste synkronisering',
    pendingItems: 'Väntande objekt',
    syncNow: 'Synkronisera nu',
    syncing: 'Synkroniserar...',
    syncSuccess: 'Synkroniseringen lyckades',
    syncFailed: 'Synkroniseringen misslyckades',
    outbox: 'Utkorg',
    inbox: 'Inkorg',
    configuration: 'Konfiguration',
    targetUrl: 'Mål-URL',
    apiKey: 'API-nyckel',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Karta',
    layers: 'Lager',
    requests: 'Förfrågningar',
    hubs: 'Knutpunkter',
    facilities: 'Inrättningar',
    routes: 'Rutter',
    showAll: 'Visa alla',
    hideAll: 'Dölj alla',
    zoomIn: 'Zooma in',
    zoomOut: 'Zooma ut',
    resetView: 'Återställ vy',
    satellite: 'Satellit',
    terrain: 'Terräng',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Kartrutor serveras lokalt',
    tilesOnline: 'Kartrutor laddas från onlineservrar',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistik',
    overview: 'Översikt',
    requestsByStatus: 'Förfrågningar per status',
    requestsByCategory: 'Förfrågningar per kategori',
    requestsByNation: 'Förfrågningar per nation',
    offersByStatus: 'Erbjudanden per status',
    patientsByCondition: 'Patienter per tillstånd',
    transportsByStatus: 'Transporter per status',
    timeline: 'Tidslinje',
    totalRequests: 'Totalt antal förfrågningar',
    totalOffers: 'Totalt antal erbjudanden',
    totalPatients: 'Totalt antal patienter',
    totalTransports: 'Totalt antal transporter',
    averageResponseTime: 'Genomsnittlig svarstid',
    completionRate: 'Slutförandegrad',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Övningsstatistik',
    overview: 'Översikt',
    byCategory: 'Per kategori',
    byNation: 'Per nation',
    byDay: 'Per dag',
    totalPatientsMoved: 'Totalt antal flyttade patienter',
    totalRequestsProcessed: 'Totalt antal behandlade förfrågningar',
    averageProcessingTime: 'Genomsnittlig handläggningstid',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Flödesdiagram',
    sankey: 'Sankey',
    nodeGraph: 'Nodgraf',
    refresh: 'Uppdatera',
    noData: 'Inga flödesdata tillgängliga',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Om',
    version: 'Version',
    systemInfo: 'Systeminformation',
    buildDate: 'Byggdatum',
    environment: 'Miljö',
    description: 'ARCOS — Avancerat kommunikationssystem för förfrågningar',
    subtitle: 'Katastrofhjälp och medicinska operationer',
    whatIsArcos: 'Vad är ARCOS? – Förklaring för övningsdeltagare',
    arcosDesc1: 'ARCOS är ett digitalt verktyg som används i denna övning för att stödja och strukturera internationell kommunikation, förfrågningar och samordningsprocesser mellan de deltagande aktörerna.',
    arcosDesc2: 'ARCOS ger en förenklad, övningsorienterad representation av de grundläggande principerna bakom dessa system.',
    arcosUsedFor: 'Under övningen används ARCOS för att representera typiska processer som:',
    arcosUsedForItem1: 'inlämning och hantering av assistansförfrågningar,',
    arcosUsedForItem2: 'samordning av och svar på stöderbjudanden från andra nationer,',
    arcosUsedForItem3: 'spårning av status och framsteg för förfrågningar,',
    arcosUsedForItem4: 'och representation av förenklade transport- eller evakueringsarbetsflöden.',
    arcosDesc3: 'Arbetsflödena i ARCOS är avsiktligt förenklade och anpassade till övningens specifika utbildningsmål.',
    arcosDesc4: 'Målet med ARCOS är inte att simulera ett perfekt eller komplett verkligt system.',
    arcosDesc5: 'Om vissa element skiljer sig från verkliga procedurer du känner till, är detta förväntat.',
    facilitatedBy: 'Faciliterat av MMCC-E',
    dhcInitiative: 'Digital Health Corner (DHC) är ett gemensamt initiativ av:',
    dhcAuthor1: 'Sven Giegerich — Tyska försvarsmakten',
    dhcAuthor2: 'Mohamad Haji — Belgiska försvaret',
    dhcConviction: 'Född ur övertygelsen att innovation frodas där passion möter pragmatism.',
    dhcInspired: 'Inspirerade av MMCC-E började vi skapa enkla men effektiva lösningar.',
    dhcLove: 'Vi gör det för att vi älskar vårt arbete och tror att digitala idéer kan omforma samarbetet inom militär hälsovård.',
    dhcOpen: 'DHC är en öppen plattform: fri från hierarkier, öppen för idéer, driven av nyfikenhet.',
    dhcClosing: 'Digital Health Corner – där nyfikenhet möter samarbete.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentation',
    gettingStarted: 'Komma igång',
    userGuide: 'Användarhandbok',
    faq: 'Vanliga frågor',
    troubleshooting: 'Felsökning',
    apiReference: 'API-referens',
    downloadTemplate: 'Ladda ner mall',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Patientimport',
    uploadFile: 'Ladda upp fil',
    selectFile: 'Välj fil',
    preview: 'Förhandsgranskning',
    importNow: 'Importera nu',
    importing: 'Importerar...',
    importSuccess: '{{count}} patienter importerade',
    importFailed: 'Importen misslyckades',
    downloadTemplate: 'Ladda ner mall',
    dragDrop: 'Dra och släpp en fil här, eller klicka för att välja',
    supportedFormats: 'Format som stöds: XLSX, XLS, CSV',
    rowsFound: '{{count}} rader hittades',
    validRows: '{{count}} giltiga rader',
    invalidRows: '{{count}} ogiltiga rader',
    duplicateRows: '{{count}} dubbletter',
    previewData: 'Förhandsgranska data',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transportplanering',
    planRoute: 'Planera rutt',
    routeBuilder: 'Ruttplanerare',
    addWaypoint: 'Lägg till vägpunkt',
    removeWaypoint: 'Ta bort vägpunkt',
    estimatedDuration: 'Beräknad varaktighet',
    distance: 'Avstånd',
    selectVehicle: 'Välj fordon',
  },

  transportBooking: {
    title: 'Transportbokning',
    bookTransport: 'Boka transport',
    availableSlots: 'Tillgängliga platser',
    bookingConfirmed: 'Bokning bekräftad',
    cancelBooking: 'Avboka',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapacitetsplanering',
    totalCapacity: 'Total kapacitet',
    usedCapacity: 'Använd kapacitet',
    availableCapacity: 'Tillgänglig kapacitet',
    utilizationRate: 'Utnyttjandegrad',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Resursmallar',
    dayTemplates: 'Dagsmallar',
    createTemplate: 'Skapa mall',
    editTemplate: 'Redigera mall',
    deleteTemplate: 'Radera mall',
    templateName: 'Mallnamn',
    applyTemplate: 'Tillämpa mall',
    noTemplates: 'Inga mallar hittades',
    confirmDelete: 'Är du säker på att du vill radera denna mall?',
    confirmApply: 'Är du säker på att du vill tillämpa denna mall? Detta skriver över befintliga data.',
    exportTemplates: 'Exportera mallar',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Meddelandefält',
    createAnnouncement: 'Skapa meddelande',
    editAnnouncement: 'Redigera meddelande',
    deleteAnnouncement: 'Radera meddelande',
    message: 'Meddelande',
    startTime: 'Starttid',
    endTime: 'Sluttid',
    active: 'Aktiv',
    noAnnouncements: 'Inga meddelanden',
    confirmDelete: 'Är du säker på att du vill radera detta meddelande?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Sök...',
      noResults: 'Inga resultat hittades',
      showing: 'Visar {{from}} till {{to}} av {{total}}',
      rowsPerPage: 'Rader per sida',
      previousPage: 'Föregående sida',
      nextPage: 'Nästa sida',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Bekräfta',
      cancel: 'Avbryt',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Osparade ändringar',
      message: 'Du har osparade ändringar. Är du säker på att du vill lämna denna sida?',
      stay: 'Stanna på sidan',
      leave: 'Lämna sidan',
    },
    // EmptyState
    emptyState: {
      noData: 'Inga data tillgängliga',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Något gick fel',
      message: 'Ett oväntat fel uppstod. Försök att ladda om sidan.',
      retry: 'Försök igen',
    },
    // ExportButton
    exportButton: {
      export: 'Exportera',
      exporting: 'Exporterar...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Skriv ut',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Utkast',
      review: 'Granskning',
      published: 'Publicerad',
      selection: 'Urval',
      inTransit: 'Under transport',
      completed: 'Slutförd',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Onlineinstans',
      message: 'Skrivskyddat läge. Data synkroniseras från den primära servern.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Du visar som',
      loggedInAs: 'inloggad som {{nation}}',
      returnTo: 'Återgå till {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Sök sidor, förfrågningar, transporter...',
      searching: 'Söker...',
      noResults: 'Inga resultat för "{{query}}"',
      navigate: 'Navigera',
      select: 'Välj',
      close: 'Stäng',
      pages: {
        dashboard: 'Instrumentpanel',
        requests: 'Förfrågningar',
        transports: 'Transporter',
        map: 'Karta',
        myPatients: 'Mina patienter',
        flowDiagram: 'Flödesdiagram',
        statistics: 'Statistik',
        assets: 'Resurser',
        startPoints: 'Startpunkter / Knutpunkter',
        treatmentFacilities: 'Vårdinrättningar',
        users: 'Användare',
        settings: 'Inställningar',
        auditLogs: 'Granskningslogg',
        exerciseControl: 'Övningskontroll',
        dataSync: 'Datasynkronisering',
        patientImport: 'Patientimport',
        notifications: 'Aviseringar',
        documentation: 'Dokumentation',
      },
      actions: {
        importPatientsJson: 'Importera Patienter (JSON)',
        importPatientsExcel: 'Importera Patienter (Excel)',
        importUsers: 'Importera Användare (Excel)',
        importAssetTemplates: 'Importera Tillgångsmallar (Excel)',
        importDayTemplates: 'Importera Dagsmallsposter (Excel)',
        exportRequests: 'Exportera Förfrågningar (Excel)',
        exportPatients: 'Exportera Patienter (Excel)',
        exportUsers: 'Exportera Användare (Excel)',
        exportCredentials: 'Exportera Inloggningsuppgifter (PDF)',
        exportAuditExcel: 'Exportera Revisionslogg (Excel)',
        exportAuditPdf: 'Exportera Revisionslogg (PDF)',
        pagePatientImport: 'Sida för patientimport',
        pageRequestDetail: 'Sida för förfrågningsdetaljer',
        pageUsers: 'Sida för användarhantering',
        pageAssetTemplates: 'Sida för tillgångsmallar',
        pageDayTemplates: 'Sida för dagsmallar',
        pageRequests: 'Sida för förfrågningslista',
        pageAuditLogs: 'Sida för revisionslogg',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sessionen löper ut',
      message: 'Din session löper ut om <strong>{{time}}</strong>. Spara ditt arbete och logga in igen för att fortsätta.',
      dismiss: 'Avfärda',
      logoutNow: 'Logga ut nu',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Välj 4 tidszoner',
      configure: 'Konfigurera tidszoner',
      reset: 'Återställ',
      apply: 'Tillämpa',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Välj plats',
      latitude: 'Latitud',
      longitude: 'Longitud',
      clickToSelect: 'Klicka på kartan för att välja en plats',
    },
    // Modal
    modal: {
      close: 'Stäng',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Hem',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Systemunderhåll',
    message: 'Systemet återställs inför nästa övningsdag. Vänta tills processen är klar.',
    autoRefresh: 'Denna sida uppdateras automatiskt när systemet är tillgängligt igen.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Minst 10 tecken',
    uppercase: '1 versal',
    lowercase: '1 gemen',
    digit: '1 siffra',
    special: '1 specialtecken',
  },
};

export default sv;
